<section class="section-container">
  <h2 class="section-title">{{ 'integration-review-title' | translate }}</h2>

  <div>
    <iframe
      class=" frame-video frame-video__dark img-fluid"
      [src]="safeUrl"
      [title]="youtubeReviewTitle"
      allowfullscreen
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    ></iframe>
  </div>


</section>
